import { formDataRequest, getRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceGetMonthWiseExpenseReport(params) {
    return await postRequest('expense/report', params);
}

export async function serviceGetCustomExpenseReport(params) {
    return await postRequest('expense/custom/report', params);
}

export async function serviceExpenseReportExport(params) {
    return await postRequest('expense/report/export', params);
}

export async function serviceCustomExpenseReportExport(params) {
    return await postRequest('expense/custom/report/export', params);
}



